import {
  FILING_GROUP,
  FILING_GROUP_ORDER,
  FilingGroup,
} from "v2/constants/filingGroup";

const isFilingGroup = (value: string): value is FilingGroup =>
  FILING_GROUP_ORDER.some((group) => group === value);

export const toFilingGroup = (value: string | null): FilingGroup => {
  if (value && isFilingGroup(value)) {
    return value;
  }

  return FILING_GROUP.OTHER;
};
